import { render, staticRenderFns } from "./WhitelabelDetail.vue?vue&type=template&id=07408245&"
import script from "./WhitelabelDetail.vue?vue&type=script&lang=ts&"
export * from "./WhitelabelDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports